import React, { useContext, useEffect } from 'react'
import "./VideoSubmission.css";
import { newCheckmark } from '../../../images/btnIcons';
import { SpeakerContext } from '../../../context/SpeakerContext';

function VideoSubmission({ messageTxt = '', redirectionMsg = '', redirectToPage, isTelebinding = false }) {
    const { handleAudioIconDisplay } = useContext(SpeakerContext)

    const getRedirectionPageName = (msg) => {
        switch (msg) {
            case 'otp':
                return {
                    txt: 'OTP Verification',
                    path: '/generate_otp'
                }
            case 'recording':
                return {
                    txt: 'Video Consent',
                    path: '/video-consent'
                }
            case 'dd':
                return {
                    txt: 'Direct Debit',
                    path: '/direct-debit'
                }
            case 'selfie':
                return {
                    txt: 'Photo Verification',
                    path: '/selfie'
                }
            case 'feedback':
                return {
                    txt: isVideoPosv() ? 'Video Consent':'OTP Verification',
                    path: isVideoPosv() ? '/video-consent':'/generate_otp'
                }
            default:
                break
        }
    }

    const isVideoPosv =()=>{
        let vposvTag = localStorage.getItem("isVideoPosv")
        if(vposvTag){
            if(vposvTag.toLowerCase()==="y"){
                return true
            }else{
                return false
            }
        }else{
            return false
        }
    }

    useEffect(() => {
        handleAudioIconDisplay(false)
        let path = getRedirectionPageName(redirectionMsg)?.path
        let timeOut = null
        if (isTelebinding) {
            timeOut = setTimeout(() => {
                redirectToPage()
            }, 1500)
        } else {
            redirectToPage(path)
        }
        return () => {
            handleAudioIconDisplay(true)
            clearTimeout(timeOut)
        }
    }, [])

    return (
        <div className='video-submission-cntnr'>
            <div className='video-submission-content' >
                <img src={newCheckmark} alt='Checkmark' />
                <p className='submit-text'>
                    {messageTxt}
                </p>
                <p className='redirect-text'>
                   {isTelebinding
                        ? redirectionMsg
                        : `You will be automatically redirected to ${getRedirectionPageName(redirectionMsg)?.txt}`}
                </p>
            </div>
        </div>

    )
}

export default VideoSubmission